import React, {Component} from 'react';
import Logger from "../helpers/Logger";
import PricesCalendar from "./PricesCalendar";

export default class PricesCalendarContainer extends Component {
    componentDidCatch(error, info) {
        const logger = new Logger(this.props.logPath);
        logger.critical('REACT: error caught in PricesCalendarContainer', error.toString());
    }

    render() {
        return (
            <PricesCalendar
            dataParameters={this.props.parameters}
            translations={this.props.translations}
            matrix={this.props.matrix}
            suitableCities={this.props.suitableCities}
            />
        );
    }
}

export const DOMAIN = 'prices_calendar';



// WEBPACK FOOTER //
// ./src/components/PricesCalendarContainer.js